enum TypeDateNaissance {
  COMPLET = 'complet',
  MOIS_ANNEE = 'mois-annee',
  ANNEE = 'annee',
}

export default TypeDateNaissance;
